export default __webpack_public_path__ + "static/media/loading.30040b6d.svg";